module.exports = {"TXTCLI_Open":{"id":"TXTCLI_Open","defaultMessage":"Открыть"}}